import { useState } from "react";
import classes from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import LogoutModal from "../../Modals/LogoutModal/logoutModal";
import { setCurrentTab } from "../../../redux/ducks/auth";
import { useDispatch } from "react-redux";
const SidebarHeader = () => {
	const navigate = useNavigate();
	const [openLogoutModal, setOpenLogoutModal] = useState(false);
	const dispatch = useDispatch()
	const handleOnClickLogout = () => {
		setOpenLogoutModal(!openLogoutModal);
	};
	return (
		<>
			<div className={classes["header-container"]}>
				<div className={classes["nav-items"]}>
					<div
						className={classes["logout-btn"]}
						onClick={() => handleOnClickLogout()}>
						<span>Log out</span>
					</div>
					<div
						className={classes["myAccount-btn"]}
						onClick={() => {
							dispatch(setCurrentTab(0))
							navigate("/base/profile");
						}}>
						My account
					</div>
				</div>
			</div>
			<Modal
				open={openLogoutModal}
				onClose={handleOnClickLogout}
				aria-labelledby='keep-mounted-modal-title'
				aria-describedby='keep-mounted-modal-description'>
				<LogoutModal closeModal={handleOnClickLogout} />
			</Modal>
		</>
	);
};

export default SidebarHeader;
